import { Link } from "react-router-dom";

// Single-click profile linking (Collaboration Phase 2, 2026-08) — wraps a member's name/avatar
// in a link to their public profile (`/build/member/{id}`, backed by `GET /v1/build/members/
// {id}` — the SAME zero-PII `_public_member_card` projection Discovery/Collaboration already
// use, reachable by freelancer AND staff viewers alike). Deliberately NOT the internal `/build/
// f/{id}` route (staff-only `build.read`, full edit/archive surface) — that page is for NJM
// staff managing a record, this is for a peer glancing at someone's public profile. Renders
// plain, unlinked text/children whenever `freelancerId` is absent (NJM-staff authors, or any
// author with no linked freelancer record) — never a dead or 404 link.
export function MemberLink({ freelancerId, className, testId, children }) {
  if (!freelancerId) {
    return <span className={className} data-testid={testId}>{children}</span>;
  }
  return (
    <Link to={`/build/member/${freelancerId}`} className={className} data-testid={testId} onClick={(e) => e.stopPropagation()}>
      {children}
    </Link>
  );
}
